import styled from 'styled-components';

const StyledSearch = styled.div`
        position: absolute;
        top: 0px;
        left: 0%;
        opacity: ${props => props.expanded ? 1 : 0};
        pointer-events: ${props => props.expanded ? 'all' : 'none'};
        visibility: ${props => props.expanded ? 'visible' : 'hidden'};
        align-items: center;
        background-color: ${props => props.theme.palette.common.white};
        box-shadow: ${props => props.theme.shadows[2]};
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        font-size: 1.1em;
        justify-content: flex-start;
        margin: 0 auto 3px;
        padding: 0;
        width: 100%;
        max-heigth: 3em;
        transition: opacity .5s cubic-bezier(.4,0,.2,1), visibility .3s;
        
        &:focus-within {
          border-color: ${props => props.theme.palette.common.secondary};
          box-shadow: ${props => props.theme.shadows[5]};
        }
        
        & .schnoffle-button-dense {
          width: ${props => props.expanded ? '2.8rem' : '0px'};
          height: 2.8rem;
        }
    `;

export default StyledSearch;



// WEBPACK FOOTER //
// ./src/components/styles/ExpandableSearch.js